import { deletee, get, patch, post, put, upload } from "Service";

const CorporateList = (payload: any) => {
    const request = {
        subUrl: `Admin/GetAllUnverifiedCorporateUser?userType=${payload.userType}`,
        data: payload,
        isAuth: false,
    };
    return get(request);
}

const ProfessionalList = () => {
    const request = {
        subUrl: "Admin/GetAllUnverifiedProfessionalUser",
        isAuth: false,
    };
    return get(request);
}

const VerifyCorporate = (payload: any) => {
    const request = {
        subUrl: "Admin/verify-user",
        data: payload,
        isAuth: false,
    };
    return post(request);
}
const VerifyProfessional = (payload: any) => {
    const request = {
        subUrl: "Admin/verify-user",
        data: payload,
        isAuth: false,
    };
    return post(request);
}

const fetchCases = async () => {
    try {
        const request = {
            subUrl: "Admin/getAllCases",
            isAuth: false,
        };
        return await get(request);
    } catch (error) {
        console.error("Error fetching cases:", error);
        throw error;
    }
}
const fetchVerifyProfessionalList = async () => {
    try {
        const request = {
            subUrl: "Admin/getAllVerifiedProfessional",
            isAuth: false,
        };
        return await get(request);
    } catch (error) {
        console.error("Error fetching professional list:", error);
        throw error;
    }
}

const AssignCaseToProfessional = async (payload: any) => {
    try {
        const request = {
            subUrl: "Admin/assign-professional",
            data: payload,
            isAuth: false,
        };
        return await post(request);
    } catch (error) {
        console.error("Error assigning case to professional:", error);
        throw error;
    }
}

const UnassignCaseProfessional = async (payload: { caseId: number; professionalId: number }) => {
    try {
        const request = {
            subUrl: "Admin/unassign-professional",
            data: payload,
            isAuth: false,
        };
        return await post(request);
    } catch (error) {
        console.error("Error unassigning professional from case:", error);
        throw error;
    }
}

const OrderHistory = async (id: string, pageNumber: number = 1, pageSize: number = 10, searchQuery: string = "", orderType: number = 0) => {
    try {
        const request = {
            subUrl: `Cases/user/${id}?pageNumber=${pageNumber}&pageSize=${pageSize}&searchQuery=${encodeURIComponent(searchQuery)}&orderType=${orderType}`,
            isAuth: false,
        };
        return await get(request);
    } catch (error) {
        console.error("Error fetching order history:", error);
        throw error;
    }
}

const getProfile = (userId: string) => {
    const request = {
        subUrl: `get-user/${userId}`,
        isAuth: true,
    };
    return get(request);
}

const ProfileUpdate = (userId: string, payload: any, userType: string) => {
    const formattedUserType =
        userType.charAt(0).toUpperCase() + userType.slice(1).toLowerCase();
    const request = {
        subUrl: `update-user/${userId}?userType=${formattedUserType}`,
        data: payload,
        isAuth: true,
    };
    return post(request);
}

const UploadProfilePicture = (file: File, userId: string) => {
    const fd = new FormData();
    fd.append("file", file, file.name);
    const request = {
        subUrl: `${userId}/upload-profile-picture`,
        data: fd,
        isAuth: true,
    };
    return upload(request);
}

const HotlineList = () => {
    const request = {
        subUrl: "Hotline",
        isAuth: false,
    };
    return get(request);
}

const CreateHotline = (payload: any) => {
    const request = {
        subUrl: "Hotline",
        data: payload,
        isAuth: false,
    };
    return post(request);
}
const sendPaymentLink = (payload: any) => {
    const request = {
        subUrl: "Hotline/send-payment-link",
        data: payload,
        isAuth: false,
    };
    return post(request);
}

const GetAllActiveProfessionalUser = () => {
    const request = {
        subUrl: "Admin/GetAllActiveProfessionalUser",
        isAuth: false,
    };
    return get(request);
}

const getAllUnAssignedProfessionalCases = () => {
    const request = {
        subUrl: "Admin/getAllUnAssignedProfessionalCases",
        isAuth: false,
    };
    return get(request);
}

const fetchCaseDetails = async (caseId: Number) => {
    try {
        const request = {
            subUrl: `Cases/${caseId}`,
            isAuth: false,
        };
        return await get(request);
    } catch (error) {
        console.error("Error fetching case details:", error);
        throw error;
    }
};

const CreateAdminUser = (payload: any) => {
    const request = {
        subUrl: "Admin/create",
        data: payload,
        isAuth: false,
    };
    return post(request);
}

const UpdateAdminUser = (id: number | string, payload: any) => {
    const request = {
        subUrl: `Admin/update/${id}`,
        data: payload,
        isAuth: false,
    };
    return put(request);
};

const getAllAdminUsers = (orderTypeId?: number) => {
    const url = orderTypeId ? `Admin?orderTypeId=${orderTypeId}` : "Admin";
    const request = {
        subUrl: url,
        isAuth: false,
    };
    return get(request);
}

const getAllCasesWithAssignedAdminProfessional = (pageNumber = 1, pageSize = 10, searchQuery = "", professionalId?: number) => {
    let url = `Admin/getAllCasesWithAssignedAdminProfessional?pageNumber=${pageNumber}&pageSize=${pageSize}&searchQuery=${encodeURIComponent(searchQuery)}`;
    // if (professionalId) {
    //     url += `&professionalId=${professionalId}`;
    // }
    const request = {
        subUrl: url,
        isAuth: false,
    };
    return get(request);
}

const updateCaseAssignment = (caseId: number | string, payload: any) => {
    const request = {
        subUrl: `Admin/updateCaseAssignment/${caseId}`,
        isAuth: false,
        data: payload,
    };
    return put(request);
}

const RefundRequest = (payload: any) => {
    const request = {
        subUrl: "RefundRequest",
        isAuth: false,
        data: payload,
    };
    return post(request);
}

const getRefundRequest = () => {
    const request = {
        subUrl: `RefundRequest/admin-requests`,
        isAuth: false,
    };
    return get(request);
}

const getAllUsers = (userType?: string, page: number = 1, pageSize: number = 50, search?: string) => {
    let url = "Admin/users";
    const params = new URLSearchParams();

    if (userType) {
        params.append("userType", userType);
    }
    if (search) {
        params.append("search", search);
    }
    params.append("page", page.toString());
    params.append("pageSize", pageSize.toString());

    const request = {
        subUrl: `${url}?${params.toString()}`,
        isAuth: false,
    };
    return get(request);
}

const updateUserVerifiedStatus = (payload: any) => {
    const request = {
        subUrl: "Admin/update-user-verified-status",
        isAuth: false,
        data: payload,
    };
    return put(request);
}

const getWhatsAppChatLogs = (page = 1, pageSize = 10, search = "") => {
    const request = {
        subUrl: `Admin/wa-chat-logs?page=${page}&pageSize=${pageSize}&search=${encodeURIComponent(search)}`,
        isAuth: false,
    };
    return get(request);
}

const getAllEmitraUsers = () => {
    const request = {
        subUrl: "Admin/emitra-users",
        isAuth: false,
    };
    return get(request);
}

const getWhatsAppUsers = (page = 1, pageSize = 10, search = "") => {
    const request = {
        subUrl: `Admin/wa-users?page=${page}&pageSize=${pageSize}&search=${encodeURIComponent(search)}`,
        isAuth: false,
    };
    return get(request);
}

const getUnpaidCasesForEmitra = (emitraId: string | number) => {
    const request = {
        subUrl: `Payments/cases-eligible-for-emitra-payout/${emitraId}`,
        isAuth: false,
    };
    return get(request);
}

const getSkills = () => {
    const request = {
        subUrl: "Admin/skills",
        isAuth: false,
    };
    return get(request);
}

const submitEmitraPayoutRequest = (payload: any) => {
    const request = {
        subUrl: "Payments/request-emitra-payouts",
        data: payload,
        isAuth: false,
    };
    return post(request);
}

const getCompletedPayouts = (type?: string) => {
    const request = {
        subUrl: type ? `Payments/completed-payouts?type=${type}` : "Payments/completed-payouts",
        isAuth: false,
    };
    return get(request);
}

const exportWhatsAppChatLogs = () => {
    const request = {
        subUrl: "Admin/export-wa-chat-logs",
        isAuth: false,
        excel: true,
    };
    return get(request);
}

const deleteProfessionalCertificate = (id: number) => {
    const request = {
        subUrl: `attachments/delete-professional-certificate/${id}`,
        isAuth: false,
    };
    return deletee(request);
}

const exportWhatsAppUsers = () => {
    const request = {
        subUrl: "Admin/export-wa-users",
        isAuth: false,
        excel: true,
    };
    return get(request);
}

const getUserFeedbacks = (page = 1, pageSize = 10) => {
    const request = {
        subUrl: `Admin/user-feedbacks?page=${page}&pageSize=${pageSize}`,
        isAuth: false,
    };
    return get(request);
}

const getMyPayouts = () => {
    const request = {
        subUrl: "Payments/my-payouts",
        isAuth: false,
    };
    return get(request);
}

const getEMitraCases = () => {
    const request = {
        subUrl: "Admin/emitra-cases",
        isAuth: false,
    };
    return get(request);
}

const payEMitraCommission = (caseId: number, payload: any) => {
    const request = {
        subUrl: `Admin/pay-emitra-commission/${caseId}`,
        isAuth: false,
        data: payload,
    };
    return post(request);
}

const getPendingPayouts = (type?: string) => {
    const request = {
        subUrl: type ? `Payments/pending-payouts?type=${type}` : "Payments/pending-payouts",
        isAuth: false,
    };
    return get(request);
}

const deleteCase = (caseId: number) => {
    const request = {
        subUrl: `Admin/cases/${caseId}`,
        isAuth: false,
    };
    return deletee(request);
}

const generateZohoInvoice = (caseId: number, data: { professionalFees: number, nlpCommission: number, outOfPocketExpenses: number, governmentFees: number, sendEmail: boolean }) => {
    const request = {
        subUrl: `Admin/cases/${caseId}/generate-zoho-invoice`,
        isAuth: false,
        data: data
    };
    return post(request);
}

const createMissingSupportCases = () => {
    const request = {
        subUrl: "Admin/create-missing-support-cases",
        isAuth: false,
    };
    return post(request);
}

const createTicket = (payload: any) => {
    const request = {
        subUrl: "Tickets",
        isAuth: false,
        data: payload,
    };
    return post(request);
}

const getTickets = (page = 1, pageSize = 10, status = "", search = "") => {
    let url = `Tickets?page=${page}&pageSize=${pageSize}`;
    if (status) url += `&status=${status}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    const request = {
        subUrl: url,
        isAuth: false,
    };
    return get(request);
}

const updateTicketStatus = (id: number, status: string) => {
    const request = {
        subUrl: `Tickets/${id}/status`,
        isAuth: false,
        data: { status },
    };
    return put(request);
}

const getMyTickets = (page = 1, pageSize = 10, status = "") => {
    let url = `Tickets/my?page=${page}&pageSize=${pageSize}`;
    if (status) url += `&status=${status}`;
    const request = {
        subUrl: url,
        isAuth: false,
    };
    return get(request);
}

const getCallbackRequests = (page = 1, pageSize = 10, search = "") => {
    let url = `CallbackRequest?page=${page}&pageSize=${pageSize}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    const request = {
        subUrl: url,
        isAuth: false,
    };
    return get(request);
}

const exportCallbackRequests = () => {
    const request = {
        subUrl: "CallbackRequest/export",
        isAuth: false,
        excel: true,
    };
    return get(request);
}

const sendProfileReminderEmail = (userId: number) => {
    const request = {
        subUrl: `Admin/remind-professional/${userId}`,
        isAuth: false,
    };
    return post(request);
}

const getAllUnAssignedAdminCases = () => {
    const request = {
        subUrl: "Admin/getAllUnAssignedAdminCases",
        isAuth: false,
    };
    return get(request);
};

const assignAdminBatch = (payload: { adminId: number; caseIds: number[] }) => {
    const request = {
        subUrl: "Admin/assignAdminBatch",
        data: payload,
        isAuth: false,
    };
    return post(request);
};

const AdminApi = {
    CorporateList,
    VerifyCorporate,
    VerifyProfessional,
    ProfessionalList,
    fetchVerifyProfessionalList,
    AssignCaseToProfessional,
    fetchCases,
    OrderHistory,
    getProfile,
    ProfileUpdate,
    UploadProfilePicture,
    HotlineList,
    CreateHotline,
    sendPaymentLink,
    GetAllActiveProfessionalUser,
    fetchCaseDetails,
    getAllUnAssignedProfessionalCases,
    UnassignCaseProfessional,
    CreateAdminUser,
    UpdateAdminUser,
    getAllAdminUsers,
    getAllCasesWithAssignedAdminProfessional,
    updateCaseAssignment,
    RefundRequest,
    getRefundRequest,
    getAllUsers,
    updateUserVerifiedStatus,
    getWhatsAppChatLogs,
    getWhatsAppUsers,
    getSkills,
    exportWhatsAppChatLogs,
    exportWhatsAppUsers,
    deleteProfessionalCertificate,
    getUserFeedbacks,
    getEMitraCases,
    payEMitraCommission,
    getAllEmitraUsers,
    getUnpaidCasesForEmitra,
    submitEmitraPayoutRequest,
    getCompletedPayouts,
    getPendingPayouts,
    getMyPayouts,
    deleteCase,
    generateZohoInvoice,
    createMissingSupportCases,
    createTicket,
    getTickets,
    updateTicketStatus,
    getMyTickets,
    getCallbackRequests,
    exportCallbackRequests,
    sendProfileReminderEmail,
    getAllUnAssignedAdminCases,
    assignAdminBatch
};

export default AdminApi;
